import { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import AppModal from "../../common/AppModal";
import EditCustomerModal from "./customer-edit-model";
import EditIcon from "../../IconComp/editIcon";
import ViewHistoryIcon from "../../IconComp/viewHisIcon";
import CustomerPaymentHisModal from "./customer-payment-modal";
import { useAppSelector } from "../../../app/hooks";

interface IProps {
  customerInfo: any;
  getCustomerHistory: any;
  setOpenSnackbar: any
}
export const CustomerActionsModal = ({
  customerInfo,
  getCustomerHistory,
  setOpenSnackbar
}: IProps) => {

  const [openModal, setOpenModal] = useState(false);
  const [paymentHistoryModal, setPaymentHistoryModal] = useState(false);
  const [customerId, setCustomerId] = useState<string | null>(null);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handlePaymentHistoryModal = (id: string) => {
    setCustomerId(id);
    setPaymentHistoryModal(true);
  };

  const handleClosePaymentHistoryModal = () => {
    setPaymentHistoryModal(false);
  };

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Tooltip title="Edit Customer" arrow>
          <Box
            component="span"
            sx={{ cursor: "pointer", display: "flex" }}
            onClick={handleOpenModal}
          >
            <EditIcon />
          </Box>
        </Tooltip>

        <Tooltip title="View Payment History" arrow>
          <Box
            component="span"
            sx={{ cursor: "pointer", display: "flex" }}
            onClick={() => handlePaymentHistoryModal(customerInfo.id)}
          >
            <ViewHistoryIcon />
          </Box>
        </Tooltip>
      </Box>

      <AppModal
        title="Edit Customer"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <EditCustomerModal
          getCustomerHistory={getCustomerHistory}
          handleClose={handleCloseModal}
          setOpenSnackbar={setOpenSnackbar}
          customerInfo={customerInfo}
        />
      </AppModal>
      <AppModal
        title="Payment History"
        open={paymentHistoryModal}
        handleClose={handleClosePaymentHistoryModal}
        fullScreen={false}
        maxWidth="md"
      >
        <CustomerPaymentHisModal
          customerId={customerId}
          getCustomerHistory={getCustomerHistory}
          setOpenSnackbar={setOpenSnackbar}
        />
      </AppModal>
     
    </>
  );
};
